// extracted by mini-css-extract-plugin
export default {"detail":"DetailsAbout_detail__01YWF"};